import { Accordion, AccordionTab } from "primereact/accordion"
import { Button } from "primereact/button";

const WizardPanelSection = ({ myPanels, activeIndex, isExerciseSelected, setActiveIndex, selectedPanels, step, handleSelectPanel, handleAddExercise, clickedPanels, t }: any) => {

    const handleSelectPanelOverride = (panel: any, isSelected: any, e:any) => {
        e.stopPropagation();
        handleSelectPanel(panel, isSelected);
    }

    const headerContent = (panel: any, isSelected:boolean, howManyExerciseSelectedText:any, idx:number) => {
        return (
            <div
                className="flex align-items-center justify-content-between m-2 pr-2"
                style={{
                    height: "2rem",
                }}
            >
                <div className="flex gap-4 align-items-center w-full">
                    {step !== 4 && (
                        <div  className="p-3 w-3rem h-3rem flex align-items-center justify-content-center" style={{backgroundColor: "rgba(234, 235, 240, 1)", borderRadius: "10px", color: "#2D3967"}}>
                            <i className={`pi pi-angle-${activeIndex === idx ? "up" : "down"} text-3xl`}></i>
                        </div>
                    )}
                    <p className={`${step !== 3 ? "text-sm white-space-nowrap line-height-3 overflow-hidden text-overflow-ellipsis" : "text-lg"}`}>{panel.name} 
                        {step !== 3 && howManyExerciseSelectedText && 
                            <>
                                <br /> 
                                <span className={` text-xs`}>{howManyExerciseSelectedText}</span>
                            </>
                        }
                    </p>
                </div>
                {step === 3 && (
                    <div className="flex justify-content-center align-items-center gap-2">
                        {howManyExerciseSelectedText && <span>{howManyExerciseSelectedText}</span>}
                        <Button
                            style={{
                                backgroundColor: isSelected ? "#F6C9D1" : "#E4EAFF",
                                border: "none",
                                borderRadius: "10px",
                                height: "3rem",
                                width: "8rem",
                                minWidth: "8rem",
                                maxWidth: "8rem",
                                boxSizing: "border-box",
                                color: isSelected ? "#E3506B" : "#576185",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                padding: "0 0.75rem",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}
                            onClick={(e:any) => {
                                if(step === 3) {
                                    handleSelectPanelOverride(panel, isSelected, e)
                                }
                            }}
                        >
                            <span className="font-normal flex align-items-center gap-2" style={{ justifyContent: "center", width: "100%" }}>
                                <i className={`pi ${isSelected ? "pi-minus" : "pi-plus"} text-sm`}></i>
                                {isSelected ? t("remove") : t("select")}
                            </span>
                        </Button>
                    </div>
                )}
            </div>
        )
    }

    const exerciseDivs = (panelExerciseList: any, isPanelLengthGreatherThanFour: boolean) => {
        return panelExerciseList.exerciseProcedure.map((exercise: any,index:any) => {
            const isSelected = isExerciseSelected(exercise); 
            return (
                <div key={index} className="flex flex-column">
                    <div
                        className="flex align-items-center justify-content-between my-1 mx-2 p-2 pr-5" style={{ borderRadius: "10px", }}>
                        <div className="flex justify-content-between align-items-center w-full">
                            <div className="flex gap-4 align-items-center">
                                <img src={exercise.exerciseImg} width={50} height={50} style={{ backgroundColor: "#FFFFFF", borderRadius: "10px" }} />
                                <p className="font-bold text-sm" style={{ color: "#2D3967" }}>{exercise.exerciseName}</p>
                            </div>
                            {isPanelLengthGreatherThanFour && (
                                <Button 
                                    style={{
                                        backgroundColor: isSelected ? "#F6C9D1" : "#E4EAFF",
                                        border: "none",
                                        color: isSelected ? "#E3506B" : "#576185",
                                        borderRadius: "10px",
                                        height: "2.5rem", 
                                        width: "2.5rem", 
                                        minWidth: "2.5rem",
                                        maxWidth: "2.5rem",
                                        padding: "0"
                                    }}
                                    text
                                    icon={`pi pi-${isSelected ? "minus" : "plus"}`}
                                    onClick={() => handleAddExercise(panelExerciseList.id, exercise, isSelected)}
                                />
                            )}
                        </div>
                    </div>
                    {index !== panelExerciseList.exerciseProcedure.length-1 && <div style={{border:"1px solid #e5e7eb"}}></div>} 
                </div>
            )
        })
    }

    const createDynamicTabs = () => {
        return myPanels.map((panel: any, index:number) => {
            const isPanelLengthGreatherThanFour = panel?.exerciseProcedure?.length > 3;

            let isSelected = false;

            const selectedExerciseCount =
                panel?.exerciseProcedure?.filter((exercise: any) =>
                    isExerciseSelected(exercise)
                ).length ?? 0;

            const isSomeExerciseSelected = panel?.exerciseProcedure?.some((exercise:any) =>
                isExerciseSelected(exercise))

            if (clickedPanels.some((p:any) => p === panel.id) && isSomeExerciseSelected) {
                isSelected = true;
            } 

            let howManyExerciseSelectedText = "";

            if(selectedExerciseCount > 0) {
                howManyExerciseSelectedText = `${selectedExerciseCount}/${panel?.exerciseProcedure?.length}`
            }

            return (
                <AccordionTab key={panel.id} header={() => headerContent(panel, isSelected, howManyExerciseSelectedText, index)} pt={{
                        headerAction: () => ({
                            style: {
                                backgroundColor: isSelected ? '#2D3967' : '#FFFFFF',
                                color: isSelected ? '#FFFFFF' : '#2D3967',
                                borderRadius: '16px',
                                cursor: `${step === 3 ? "pointer" : "default"}`
                            }
                        })
                    }}>
                    {exerciseDivs(panel, isPanelLengthGreatherThanFour)}
                </AccordionTab>
            );
        });
    };

    return (
        <div className="w-full exercisePanelsAccordion overflow-auto">
            <Accordion 
                activeIndex={activeIndex} 
                onTabChange={(e:any) => {
                    if(step === 3) {
                        setActiveIndex(e.index);
                    }
                }}
            >
                {createDynamicTabs()}
            </Accordion>
        </div>
    )
}

export default WizardPanelSection;